import React from 'react';

import { Skeleton, SkeletonSize } from '@/shared/ui';

type SkeletonInfoProps = {
    label?: string;
    customClass?: string;
};

export const SkeletonInfo: React.FC<SkeletonInfoProps> = ({ label, customClass }) => (
    <div className={`flex flex-col text-sm leading-4 ${customClass}`}>
        <div>{label}</div>
        <Skeleton size={SkeletonSize.Small} className='!w-[30px] [&>span]:!min-w-[20px]' />
    </div>
);
